// @flow
import React from 'react';
import 'app/common/react/components/DeprecatedPinRep/styles/Saved.scss';
import cx from 'classnames';
import i18n from 'app/common/lib/i18n';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import { Text } from 'gestalt';

type Props = {| isNewlySaved: boolean, name: string, url: ?string |};
type State = {| showBoardName: boolean |};

const textProps = { color: 'white', size: 'xl' };
// Keep boardTransitionTimeout in sync with .SavedAnimation &.saved animation length but 50ms shorter.
const BOARD_TRANSITION_TIMEOUT = 950;

class Saved extends React.Component<Props, State> {
  state = { showBoardName: false };

  componentDidMount() {
    this.timer = setTimeout(() => {
      this.setState({ showBoardName: true });
    }, BOARD_TRANSITION_TIMEOUT);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  timer: TimeoutID;

  render() {
    const { showBoardName } = this.state;
    const { isNewlySaved, name, url } = this.props;

    let displayText;
    if (isNewlySaved && !showBoardName) {
      displayText = (
        <Text {...textProps}>{i18n._('Saved!', 'Indication that a pin has been saved')}</Text>
      );
    } else {
      const nameElement = (
        <Text {...textProps} truncate weight="bold">
          {name}
        </Text>
      );

      displayText = url ? <NavigateLink to={url}>{nameElement}</NavigateLink> : nameElement;
    }

    let className;
    if (isNewlySaved) {
      className = showBoardName ? 'board' : 'saved';
    }

    return (
      <div data-test-id="savedInfo" className={cx('SavedAnimation', className)}>
        {displayText}
      </div>
    );
  }
}

export default Saved;
